module.exports = __webpack_public_path__ + "media/images/indigo/app-store-fa67958ca62e9209cc208708223a757f.svg";